import type { Price } from '@shared/dream-components';

import { defaultCurrency } from '~/constants/localizationDefaults';

import getCheckoutAmountCents from '../utils/getCheckoutAmountCents';

export const generateInitialPaymentRequest = (selectedPrice: Price, donationAmountCents: number) => {
  return {
    currency: selectedPrice?.currency || defaultCurrency,
    label: selectedPrice?.cta || 'Pay now',
    amount: getCheckoutAmountCents(selectedPrice, donationAmountCents),
  };
};
